.container {
    padding: 10px;
    max-width: 200px;
}
